let env = {};

env.baseURL = 'https://api.hml.ares-despacho.com.br/api/v1/';
env.normalURL = 'https://api.hml.ares-despacho.com.br/';
env.mode = 'homolog';

env.wsEnabled = true;
env.wsKey     = '6e4af85812abf40b9c1b';
env.wsHost    = 'ws.hml.ares-despacho.com.br';
env.wsPort    = 443;
env.wssPort   = 443;
env.wsScheme  = 'https';
env.wsCluster = 'mt1';

export default env
